const digest = '12a91d810ca91b7b425458a99cf167aa1739517f4ce77f6ecb3ed59445550a8e';
const css = `._emptyDay_o7omn_1{height:2.75rem;width:2.75rem}@media (max-width:799px){._emptyDay_o7omn_1{width:100%}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'emptyDay': '_emptyDay_o7omn_1' };
export const emptyDay = '_emptyDay_o7omn_1';
export { css, digest };